export type NoraSpeechAudio = {
  chunkId: string
  audioBase64: string
  contentType: string
}

export const writeSpeechChunk = (_speech: NoraSpeechAudio): Promise<string> =>
  Promise.reject(new Error('Nora speech playback is unavailable on web'))

export const deleteSpeechChunk = (_filePath: string): Promise<void> => Promise.resolve()

export const speechFileUri = (filePath: string) => filePath
